/**
 * Logs the provided arguments to the console with a "vm2log =>" prefix and returns the first argument.
 *
 * @param {...any} args - The arguments to log and process.
 * @returns {any} The first argument passed in, or `undefined` if no arguments were provided.
 */
function vm2log(...args) {
  console.log('  vm2log =>', ...args);
  return args?.[0];
}

window.vm2log = vm2log;
